<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get("shared.foodGroups")}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get("shared.dashboard")}}</span>
        </li>
        <li>
          <i class="fa fa-cutlery"></i>
          <span>{{$ml.get("shared.diningHall")}}</span>
        </li>
        <li>
          <span>{{$ml.get("shared.foodGroups")}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-3">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get("foodGroups.foodGroupList")}}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <input
                  type="text"
                  :placeholder="$ml.get('general.search')"
                  v-model="searchText"
                  class="form-control"
                  autocomplete="false"
                  style="margin-bottom:10px;"
                />
              <div
                v-show="foodGroupList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="foodGroup in foodGroupList" :key="foodGroup.id">
                      <td>{{foodGroup.name}}</td>
                      <td class="pull-right">
                        <button
                          type="button"
                          @click="getFoodGroup(foodGroup.id)"
                          class="btn btn-primary btn-sm"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="foodGroupList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get("foodGroups.foodGroupNotRecord")}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{$ml.get("foodGroups.foodGroupInformation")}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button
                  type="button"
                  @click="newFoodGroup()"
                  class="btn btn-sm btn-warning "
                >{{$ml.get("foodGroups.newFoodGroup")}}</button>
              </div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>{{$ml.get("foodGroups.groupName")}}</label>
                    <input
                      v-model="foodGroup.name"
                      type="text"
                      class="form-control"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>{{$ml.get("foodGroups.groupType")}}-{{foodGroup.type}}</label>
                    <select @change="changeGroupType($event)" class="form-control">
                      <option :selected="foodGroup.type == 1" value="1">{{$ml.get("foodGroups.deserveType")}}</option>
                      <option :selected="foodGroup.type == 2" value="2">{{$ml.get("foodGroups.creditType")}}</option>
                      <option :selected="foodGroup.type == 3" value="3">{{$ml.get("foodGroups.balanceType")}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <!--<div class="col-sm-12" align="center" style="margin-bottom:10px;">
                  <span class="form-control checkbox">
                    <label>
                      <input
                        type="checkbox"
                        :checked="foodGroup.singleFoodEachMeal"
                        @change="foodGroup.singleFoodEachMeal==true ? foodGroup.singleFoodEachMeal=false : foodGroup.singleFoodEachMeal=true"
                      />
                      Her Öğünde Tek Yemek Yensin
                    </label>
                  </span>
                </div>-->
                <div class="col-sm-12" align="center" style="margin-bottom:10px;">
                  <div class="form-group">
                    <label>{{$ml.get("foodGroups.dailyMealEatingCount")}}</label>
                    <input class="form-control" type="number" v-model="foodGroup.singleFoodEachMeal" min="0" />
                  </div>
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button
                  v-show="!isNewFoodGroup"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-sil"
                  class="btn btn-sm btn-danger "
                  style="margin: 5px; width:120px;"
                >{{$ml.get("general.delete")}}</button>
                <button
                  v-show="isNewFoodGroup"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-kaydet"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get("general.save")}}</button>
                <button
                  v-show="!isNewFoodGroup"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-guncelle"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get("general.update")}}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{$ml.get("foodGroups.meals")}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button
                  type="button"
                  class="btn btn-sm btn-primary "
                  data-toggle="modal"
                  data-target="#modal-mealName"
                ><i class="fa fa-cutlery"></i> {{$ml.get("foodGroups.mealDefinitions")}}</button>
                <button
                  v-show="!isNewFoodGroup"
                  @click="newFoodMeal()"
                  type="button"
                  class="btn btn-sm btn-warning "
                  data-toggle="modal"
                  data-target="#modal-meal"
                ><i class="fa fa-plus"></i> {{$ml.get("foodGroups.newMeal")}}</button>
              </div>
            </div>
            <div class="box-body">
              <div
                v-show="mealList.length > 0"
                class="table-responsive no-padding"
                :style="windowMealHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="meal in mealList" :key="meal.id">
                      <td>
                        <span v-show="meal.day == 1" class="label label-primary">{{$ml.get("general.monday")}}</span>
                        <span v-show="meal.day == 2" class="label label-info">{{$ml.get("general.tuesday")}}</span>
                        <span v-show="meal.day == 3" class="label label-warning">{{$ml.get("general.wednesday")}}</span>
                        <span v-show="meal.day == 4" class="label label-danger">{{$ml.get("general.thursday")}}</span>
                        <span v-show="meal.day == 5" class="label label-success">{{$ml.get("general.friday")}}</span>
                        <span v-show="meal.day == 6" class="label label-primary">{{$ml.get("general.saturday")}}</span>
                        <span v-show="meal.day == 7" class="label label-info">{{$ml.get("general.sunday")}}</span>
                      </td>
                      <td>{{getMealNameFromId(meal.mealNameId)}}</td>
                      <td>
                        <span
                          class="badge label-success"
                        >{{meal.startDate | toDateFormatGet("ss:dd")}}</span> -
                        <span
                          class="badge label-danger"
                        >{{meal.endDate | toDateFormatGet("ss:dd")}}</span>
                      </td>
                      <td class="pull-right">
                        <button
                          @click="getFoodMeal(meal.id)"
                          type="button"
                          class="btn btn-primary btn-sm "
                          data-toggle="modal"
                          data-target="#modal-meal"
                        >
                          <i class="fa fa-edit"></i>
                        </button>
                        <button
                          @click="deleteMeal(meal.id)"
                          type="button"
                          class="btn btn-danger btn-sm "
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="mealList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get("foodGroups.mealNotFoundSelectedFoodGroups")}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingMeals">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <!-- /.MODAL START-->
        <div class="modal modal-info fade" id="modal-guncelle">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                <h4 class="modal-title">
                  <span>{{$ml.get("general.update")}}</span>
                </h4>
              </div>
              <div class="modal-body">
                <div>
                  <span>{{this.foodGroup.name}}</span>
                </div>
                <br />
                <p></p>
                <span>{{$ml.get("foodGroups.foodGroupUpdateIsContinue")}}</span>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">
                  <i class="fa fa-remove"></i>
                  <span>{{$ml.get("general.cancel")}}</span>
                </button>
                <button @click="saveFoodGroup()" class="btn btn-info" data-dismiss="modal">
                  <i class="fa fa-refresh"></i>
                  <span>{{$ml.get("general.update")}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- /.MODAL END -->
        <!-- /.MODAL START-->
        <div class="modal modal-success fade" id="modal-kaydet">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                <h4 class="modal-title">
                  <span>{{$ml.get("general.save")}}</span>
                </h4>
              </div>
              <div class="modal-body">
                <p>{{this.foodGroup.name}}</p>
                <span>{{$ml.get("foodGroups.foodGroupSaveIsContinue")}}</span>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">
                  <i class="fa fa-remove"></i>
                  <span>{{$ml.get("general.cancel")}}</span>
                </button>
                <button @click="saveFoodGroup()" class="btn btn-success" data-dismiss="modal">
                  <i class="fa fa-check"></i>
                  <span>{{$ml.get("general.save")}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- /.MODAL END -->
        <!-- /.MODAL START-->
        <div class="modal modal-danger fade" id="modal-sil">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                <h4 class="modal-title">
                  <span>{{$ml.get("general.delete")}}</span>
                </h4>
              </div>
              <div class="modal-body">
                <div>
                  <span>{{this.foodGroup.name}}</span>
                </div>
                <br />
                <p></p>
                <span>{{$ml.get("foodGroups.foodGroupDeleteIsContinue")}}</span>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">
                  <i class="fa fa-remove"></i>
                  <span>{{$ml.get("general.cancel")}}</span>
                </button>
                <button @click="deleteFoodGroup()" class="btn btn-danger" data-dismiss="modal">
                  <i class="fa fa-trash"></i>
                  <span>{{$ml.get("general.delete")}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- /.MODAL END -->
        <!-- /.MODAL START-->
        <div class="modal fade" id="modal-meal">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                <h4 class="modal-title">
                  <span v-show="isNewMeal">{{$ml.get("foodGroups.addNewMeal")}}</span>
                  <span v-show="!isNewMeal">
                    {{getMealNameFromId(selectedMeal.mealNameId)}} :
                    <span
                      v-show="selectedMeal.day == 1"
                      class="label label-primary"
                    >{{$ml.get("general.monday")}}</span>
                    <span v-show="selectedMeal.day == 2" class="label label-info">{{$ml.get("general.tuesday")}}</span>
                    <span v-show="selectedMeal.day == 3" class="label label-warning">{{$ml.get("general.wednesday")}}</span>
                    <span v-show="selectedMeal.day == 4" class="label label-danger">{{$ml.get("general.thursday")}}</span>
                    <span v-show="selectedMeal.day == 5" class="label label-success">{{$ml.get("general.friday")}}</span>
                    <span v-show="selectedMeal.day == 6" class="label label-primary">{{$ml.get("general.saturday")}}</span>
                    <span v-show="selectedMeal.day == 7" class="label label-info">{{$ml.get("general.sunday")}}</span>
                  </span>
                </h4>
              </div>
              <div class="modal-body">
                <div class="row" style="margin-bottom:10px; margin-right:5px;">
                  <div
                    v-show="isNewMeal"
                    class="col-sm-4 table-responsive"
                    style="height:350px; overflow:auto;"
                  >
                    <h4>{{$ml.get("foodGroups.validDays")}}</h4>
                    <table class="table table-hover">
                      <tbody>
                        <tr v-for="day in dayList" :key="day.value">
                          <td class="checkbox">
                            <label style="margin-left:30px">
                              <input
                                type="checkbox"
                                name="check"
                                :checked="day.check"
                                @change="day.check==true ? day.check=false : day.check=true"
                              />
                              {{day.name}}
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div :class="isNewMeal ? 'col-sm-6' : 'col-sm-12'">
                    <div class="form-group">
                      <label>{{$ml.get("foodGroups.mealName")}}</label>
                      <select @change="changeMealName($event)" class="form-control">
                        <option value="0" :selected="selectedMeal.mealNameId == null">{{$ml.get("general.select")}}</option>
                        <option v-for="mealName in mealNameList" :key="mealName.id" :value="mealName.id" :selected="mealName.id == selectedMeal.mealNameId">{{mealName.name}}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>{{$ml.get("foodGroups.startTime")}}</label>
                      <input type="time" class="form-control" v-model="selectedMeal.startDate" />
                    </div>
                    <div class="form-group">
                      <label>{{$ml.get("foodGroups.endTime")}}</label>
                      <input type="time" class="form-control" v-model="selectedMeal.endDate" />
                    </div>
                    <div class="form-group">
                      <label>{{$ml.get("foodGroups.eatingCount")}}</label>
                      <input
                        v-model="selectedMeal.foodClaim"
                        type="number"
                        class="form-control"
                        min="1"
                        value="1"
                      />
                    </div>
                    <div class="form-group">
                      <label>{{$ml.get("foodGroups.price")}}</label>
                      <input
                        v-model="selectedMeal.price"
                        type="text"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label>{{$ml.get("foodGroups.guestPrice")}}</label>
                      <input
                        v-model="selectedMeal.price2"
                        type="text"
                        class="form-control"
                        :placeholder="$ml.get('foodGroups.guestPrice')"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger " data-dismiss="modal">
                  <i class="fa fa-remove"></i>
                  <span>{{$ml.get("general.cancel")}}</span>
                </button>
                <button
                  type="button"
                  @click="saveMeal()"
                  class="btn btn-success "
                  data-dismiss="modal"
                >
                  <i class="fa fa-check"></i>
                  <span>{{$ml.get("general.save")}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- /.MODAL END -->
        <!--ÖĞÜN ADI MODAL -->
      <div class="modal modal-primary fade" id="modal-mealName" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get("foodGroups.mealNameDefinitions")}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-5">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title">{{$ml.get("foodGroups.mealNameList")}}</h4>
                      <div class="pull-right box-tools">
                        <button @click="newMealName()" class="btn btn-sm btn-warning ">{{$ml.get("foodGroups.newMealName")}}</button>
                      </div>
                    </div>
                    <div class="box-body">
                      <div
                        v-show="mealNameList.length > 0"
                        class="table-responsive no-padding"
                        style="max-height:250px; overflow:auto; color:black;"
                      >
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="mealName in mealNameList" :key="mealName.id">
                              <td>{{mealName.name}}</td>
                              <td>
                                <button
                                  @click="selectMealName(mealName.id, mealName.name)"
                                  class="btn btn-sm btn-primary">
                                  <i class="fa fa-search"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="mealNameList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i> {{$ml.get("foodGroups.mealNameNotRecord")}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-7">
                  <div class="form-group">
                    <label>{{$ml.get("foodGroups.mealName")}}</label>
                    <input v-model="selectedMealName" type="text" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{$ml.get("general.cancel")}}</button>
              <button
                v-show="!isNewMealName"
                type="button"
                @click="deleteMealName()"
                class="btn btn-outline btn-danger"
              >
                <span>{{$ml.get("general.delete")}}</span>
              </button>
              <button type="button" @click="saveMealName()" class="btn btn-outline btn-success">
                <span v-show="isNewMealName">{{$ml.get("general.save")}}</span>
                <span v-show="!isNewMealName">{{$ml.get("general.update")}}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ÖĞÜN ADI MODAL END -->
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      isLoadingDetail: false,
      isLoadingMeals: false,
      windowHeight: window.innerHeight,
      searchText: "",
      foodGroup: {
        id: null,
        name: "",
        type: 1,
        singleFoodEachMeal: 1,
        meals: []
      },
      selectedMeal: {
        id: null,
        mealNameId: null,
        foodGroupId: null,
        day: 0,
        startDate: "00:00",
        endDate: "00:00",
        foodClaim: 0,
        price: 0,
        price2: 0
      },
      days: [
        { value: 1, name: this.$ml.get('general.monday'), check: true },
        { value: 2, name: this.$ml.get('general.tuesday'), check: true },
        { value: 3, name: this.$ml.get('general.wednesday'), check: true },
        { value: 4, name: this.$ml.get('general.thursday'), check: true },
        { value: 5, name: this.$ml.get('general.friday'), check: true },
        { value: 6, name: this.$ml.get('general.saturday'), check: true },
        { value: 7, name: this.$ml.get('general.sunday'), check: true }
      ],
      foodGroups: [],
      isNewFoodGroup: true,
      isNewMeal: true,
      isNewMealName: true,
      selectedMealName: "",
      selectedMealNameId: null,
      mealNames: []
    };
  },
  filters: {
    toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika =
        str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      var saniye =
        str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
      if (format == "gg.aa.yyyy.ss:dd") {
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    foodGroupList() {
      if(this.searchText){
        return this.foodGroups.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(v => item.name.toUpperCase().includes(v));
        });
      } else {
      return this.foodGroups;
      }
    },
    mealList() {
      return this.foodGroup.meals;
    },
    mealNameList() {
      return this.mealNames;
    },
    dayList() {
      return this.days;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowMealHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    changeMealName(event) {
      this.selectedMeal.mealNameId = event.target.value;
    },
    changeGroupType(event) {
      this.foodGroup.type = event.target.value;
    },
    checkFalseDays() {
      let aList = this.days;
      aList.forEach(doc => {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    selectedDays() {
      let selectedDays = [];
      let aList = this.days;
      aList.forEach(doc => {
        if (doc.check == true) {
          selectedDays.push(doc.value);
        }
      });
      return selectedDays;
    },
    getMealNameFromId(id){
      var mealName = this.mealNameList.filter(a => {
        return a.id == id;
      })
      if(mealName.length > 0){
        return mealName[0].name;
      } else{
        return "";
      }
    },
    selectMealName(id, name) {
      this.isNewMealName = false;
      this.selectedMealNameId = id;
      this.selectedMealName = name;
    },
    newMealName() {
      this.isNewMealName = true;
      this.selectedMealNameId = null;
      this.selectedMealName = "";
    },
    async saveMealName() {
      if (this.selectedMealName == "") {
        alertify.warning(this.$ml.get('alerts.mealNameNotBlank'));
        return;
      }
      try {
        let id = this.selectedMealNameId;
        let name = this.selectedMealName;
        if (this.isNewMealName == true) {
          const response = await this.$axios
            .post("/FoodGroups/AddMealName", {
              name: name
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get('alerts.savedSuccessfully'));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get('errors.connectionError'));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newMealName();
          this.getMealNames();
        } else {
          const response = await this.$axios
            .post("/FoodGroups/UpdateMealName/", {
              id: id,
              name: name
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get('errors.connectionError'));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newMealName();
          this.getMealNames();
        }
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    deleteMealName() {
      try {
        let id = this.selectedMealNameId;
        if (id != null) {
          const response = this.$axios
            .delete("/FoodGroups/DeleteMealName/" + id)
            .then(response => {
              this.getMealNames();
              this.newMealName();
              alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get('errors.connectionError'));
              } else {
                alertify.error(doc.message);
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    async getMealNames() {
      try {
        const mealNames = [];
        const response = await this.$axios
          .get("/FoodGroups/GetMealNames")
          .then(response => {
            response.data.forEach(doc => {
              mealNames.push({
                id: doc.id,
                name: doc.name
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.mealNames = mealNames;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    newFoodGroup() {
      this.isLoadingDetail = true;
      this.isNewFoodGroup = true;
      this.foodGroup.id = null;
      this.foodGroup.name = "";
      this.foodGroup.type = 1;
      this.foodGroup.singleFoodEachMeal = 1;
      this.foodGroup.meals = [];
      this.isLoadingDetail = false;
    },
    newFoodMeal() {
      this.isLoadingMeals = true;
      this.checkFalseDays();
      this.isNewMeal = true;
      this.selectedMeal.id = null;
      this.selectedMeal.mealNameId = null;
      this.selectedMeal.foodGroupId = null;
      this.selectedMeal.day = 0;
      this.selectedMeal.startDate = "00:00";
      this.selectedMeal.endDate = "00:00";
      this.selectedMeal.foodClaim = 0;
      this.selectedMeal.price = 0;
      this.selectedMeal.price2 = 0;
      this.isLoadingMeals = false;
    },
    async deleteMeal(id) {
      if (this.isNewMeal) {
        alertify.warning(this.$ml.get('alerts.selectedMealNotBlank'));
      } else {
        try {
          this.isLoadingDetail = true;
          const response = await this.$axios
            .delete("/FoodGroups/DeleteFoodMeal/" + id)
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          this.getFoodGroup(this.foodGroup.id);
          this.newFoodMeal();
          alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
          this.isLoadingDetail = false;
        } catch (error) {
          alertify.error("Hata Oluştu : " + error);
          this.isLoadingDetail = false;
        }
      }
    },
    async saveMeal() {
      if (this.selectedMeal.mealNameId == null || this.selectedMeal.mealNameId == 0) {
        alertify.warning(this.$ml.get('alerts.mealNameNotBlank'));
        return;
      }
      if (this.selectedMeal.startDate > this.selectedMeal.endDate) {
        alertify.warning(this.$ml.get('alerts.invalidTimeRange'));
        return;
      }
      if (this.isNewMeal) {
        this.isLoadingMeals = true;
        let selectedDays = this.selectedDays();
        try {
          this.selectedMeal.foodGroupId = this.foodGroup.id;
          let meal2 = this.selectedMeal;
          const response = await this.$axios
            .post("/FoodGroups/AddFoodMeal", {
              mealNameId: meal2.mealNameId,
              foodGroupId: parseInt(meal2.foodGroupId),
              startDate: meal2.startDate,
              endDate: meal2.endDate,
              foodClaim: parseInt(meal2.foodClaim),
              price: meal2.price,
              price2: meal2.price2,
              days: selectedDays
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingMeals = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingMeals = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.savedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getFoodGroup(meal2.foodGroupId);
          this.isNewMeal = false;
          this.isLoadingMeals = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingMeals = false;
        }
      } else {
        //GÜNCELLE
        try {
          this.selectedMeal.foodGroupId = this.foodGroup.id;
          let meal2 = this.selectedMeal;
          const response = await this.$axios
            .post("/FoodGroups/UpdateFoodMeal/" + meal2.id, {
              mealNameId: meal2.mealNameId,
              foodGroupId: parseInt(meal2.foodGroupId),
              startDate: meal2.startDate,
              endDate: meal2.endDate,
              foodClaim: parseInt(meal2.foodClaim),
              price: meal2.price,
              price2: meal2.price2
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingMeals = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingMeals = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getFoodGroup(meal2.foodGroupId);
          this.isLoadingMeals = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingMeals = false;
        }
      }
    },
    async deleteFoodGroup() {
      try {
        this.isLoadingDetail = true;
        let id = this.foodGroup.id;
        const response = await this.$axios
          .delete("/FoodGroups/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getFoodGroups();
        this.newFoodGroup();
        alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
        this.isLoadingDetail = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingDetail = false;
      }
    },
    async saveFoodGroup() {
      if (this.isNewFoodGroup) {
        if (this.foodGroup.name == "") {
          alertify.warning(this.$ml.get('alerts.foodGroupNameNotBlank'));
          return;
        }
        this.isLoadingDetail = true;
        try {
          let foodGroup2 = this.foodGroup;
          const response = await this.$axios
            .post("/FoodGroups", {
              name: foodGroup2.name,
              type: parseInt(foodGroup2.type),
              singleFoodEachMeal: foodGroup2.singleFoodEachMeal,
              meals: foodGroup2.meals
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.savedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getFoodGroups();
          this.getFoodGroup(id);
          this.isNewFoodGroup = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let foodGroup2 = this.foodGroup;
          const response = await this.$axios
            .post("/FoodGroups/" + foodGroup2.id, {
              name: foodGroup2.name,
              type: parseInt(foodGroup2.type),
              singleFoodEachMeal: foodGroup2.singleFoodEachMeal,
              meals: foodGroup2.meals
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getFoodGroups();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getFoodGroup(id) {
      try {
        this.isLoadingDetail = true;
        const response = await this.$axios
          .get("/FoodGroups/" + id)
          .then(response => {
            this.isNewFoodGroup = false;
            this.foodGroup.id = id;
            this.foodGroup.name = response.data.name;
            this.foodGroup.type = response.data.type;
            this.foodGroup.singleFoodEachMeal =
              response.data.singleFoodEachMeal;
            this.foodGroup.meals = response.data.meals;
            if (this.foodGroup.meals.length != 0) {
              let dd = this.foodGroup.meals[0].id;
              this.getFoodMeal(dd);
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoadingDetail = false;
      }
    },
    async getFoodMeal(id) {
      try {
        this.isLoadingMeals = true;
        this.checkFalseDays();
        const response = await this.$axios
          .get("/FoodGroups/GetFoodMeal/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingMeals = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingMeals = false;
                return;
              }
            }
          });
        this.isNewMeal = false;
        this.selectedMeal.id = id;
        this.selectedMeal.mealNameId = response.data.mealNameId;
        this.selectedMeal.foodGroupId = response.data.foodGroupId;
        this.selectedMeal.day = response.data.day;
        this.selectedMeal.endDate = response.data.endDate
          ? this.toDateFormat(response.data.endDate, "ss:dd")
          : "";
        this.selectedMeal.startDate = response.data.startDate
          ? this.toDateFormat(response.data.startDate, "ss:dd")
          : "";
        this.selectedMeal.foodClaim = response.data.foodClaim;
        this.selectedMeal.price = response.data.price;
        this.selectedMeal.price2 = response.data.price2;
        let aList = this.days;
        await aList.filter(function(day) {
          if (day.value == response.data.day) {
            day.check = true;
          }
        });
        this.isLoadingMeals = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoadingMeals = false;
      }
    },
    async getFoodGroups() {
      try {
        this.isLoading = true;
        const foodGroups = [];
        const response = await this.$axios
          .get("/FoodGroups")
          .then(response => {
            response.data.forEach(doc => {
              foodGroups.push({
                id: doc.id,
                name: doc.name,
                type: doc.type,
                singleFoodEachMeal: doc.singleFoodEachMeal,
                meals: doc.meals
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });

        this.foodGroups = foodGroups;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getFoodGroups();
    await this.getMealNames();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/foodGroups/FoodGroups.vue